/** How the workflow's roles and milestones read on screen.
 *
 * `client` is the City: the contract's client is the municipality, and "City"
 * is the word the office and the documents use ("City PO"). */

const OWNERS: Record<string, string> = {
  office: "Office",
  crew: "Field operators",
  client: "City",
  finance: "Finance",
};

export function ownerLabel(owner: string): string {
  return OWNERS[owner] ?? owner.charAt(0).toUpperCase() + owner.slice(1);
}

const MILESTONES: Record<string, string> = {
  qcp_accepted: "QCP accepted",
  grn_received: "GRN received",
  payment_received: "Payment received",
};

export function milestoneLabel(kind: string): string {
  const spaced = kind.replace(/_/g, " ");
  return MILESTONES[kind] ?? spaced.charAt(0).toUpperCase() + spaced.slice(1);
}

/** Whole days late, rounding up: a job six hours past its SLA is a day over,
 * not zero days over. */
export function daysOver(days: number): number {
  return Math.max(1, Math.ceil(days));
}

/** A breach rate's colour: green under one in ten, amber to one in five, red
 * beyond. */
export function breachTone(rate: number | null): "ok" | "warn" | "crit" | "quiet" {
  if (rate === null) {
    return "quiet";
  }
  if (rate > 0.2) {
    return "crit";
  }
  return rate > 0.1 ? "warn" : "ok";
}
